import React from 'react';
import { Field, ButtonRadio, Select } from '../Common';

const person = {
    id: '',
    idBeneficiaire: '',
    firstName: '',
    name: '',
    address: '',
    zipCode: '',
    city: '',
    tel: '',
    country: '79',
    email: '',
    error: {
        firstName: '',
        name: '',
        address: '',
        zipCode: '',
        city: '',
        tel: '',
        email: '',
    }
}

class PeopleToInformFrom extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addPeople: this.props.peopleToInformData && this.props.peopleToInformData.length > 0 ? '1' : '0',
            disabled: this.props.peopleToInformData && this.props.peopleToInformData.length > 0 ? false : true,
            peopleToInform: this.props.peopleToInformData && this.props.peopleToInformData.length > 0 ? this.props.peopleToInformData : [{ ...person , id: '0' }],
            countryList: this.props.countryData.list,
            error: {
                name: '',
                address: '',
                zipCode: '',
                city: '',
                date: '',
                country: '',
                telephone: '',

            }
        }
    }

    handleOnChange(key, e) {

        const value = e.target.value;
        this.setState(() => ({ [key]: value }));
        if (value === '0') {
            const id = this.state.peopleToInform.length - 1;
            if (this.state.peopleToInform !== '') {
                const peopleToInform = this.state.peopleToInform.filter(x => x.id !== '');
                this.setState(() => ({
                    peopleToInform: peopleToInform,
                    disabled: true
                }));
            }
        }

        else if (value === '1') {
            const id = this.state.peopleToInform.length + 1;
            if (this.state.peopleToInform !== '') {
                const peopleToInform = this.state.peopleToInform.filter(x => x.id !== '');
                if (peopleToInform && !peopleToInform.length){
                	const newPerson = {
                            ...person,
                            id: this.state.peopleToInform.length,
                        }
                    peopleToInform.push(newPerson);
                }
                this.setState(() => ({
                    peopleToInform: peopleToInform,
                    disabled: false
                }));
            }
        }
    }
    OnPersonPaysChange(key, i, e) {
        const value = e.target.value;
        this.setState(prevState => ({
            peopleToInform: prevState.peopleToInform.map(
                obj => (obj.id == i ? { ...obj, [key]: value } : obj)
            )
        }));
    }

    onPersonChange(key, e) {
        const index = e.target.name;
        const value = e.target.value;
        this.setState(prevState => ({
            peopleToInform: prevState.peopleToInform.map(
                obj => (obj.id == index ? { ...obj, [key]: value, error: { ...obj.error, [key]: ''} } : obj)
            )
        }));
    }
    addPerson = () => {
        const id = this.state.peopleToInform.length;
        const newPerson = {
            ...person,
            id 
        }
        this.setState(prevState => ({
            peopleToInform: [...prevState.peopleToInform, newPerson]
        }));
    }
    removePerson = (id) => {
       const _id = id;
        const peopleToInform = this.state.peopleToInform.filter(({ id }) => id !== _id);
        this.setState(() => ({ peopleToInform }));
    }
    go = (people) => {
        let submit = true;
        if (this.state.addPeople === '1') {
            people.map((obj) => {
                if (!obj.name ||
                    !obj.firstName ||
                    !obj.address ||
                    !obj.zipCode ||
                    !obj.city
                    || !obj.tel
                    || !obj.email
                    || !obj.country
                )
                    submit = false;
            })
        }

        return submit;
    }
    onSubmit = (e) => {
        e.preventDefault();
        if (this.state.addPeople === '1') {
            this.setState(prevState => ({
                peopleToInform: prevState.peopleToInform.map((obj) => {
                    const name = (!obj.name) ? ' is-invalid' : '';
                    const firstName = (!obj.firstName) ? ' is-invalid' : '';
                    const address = (!obj.address) ? ' is-invalid' : '';
                    const zipCode = (!obj.zipCode) ? ' is-invalid' : '';
                    const city = (!obj.city) ? ' is-invalid' : '';
                    const tel = (!obj.tel) ? ' is-invalid' : '';
                    const email = (!obj.email) ? ' is-invalid' : '';
                    const country = (!obj.country) ? ' is-invalid' : '';
                    obj.error = {
                        ...obj.error,
                        name,
                        firstName,
                        address,
                        zipCode,
                        city,
                        tel,
                        email,
                        country
                    }
                    return obj;
                })
            }))
            const peopleToInform = this.state.peopleToInform;
            const submit = this.go(peopleToInform);
            if (submit) {
                this.props.onPeopleToInformSubmit(peopleToInform);
            }
        }
        else {
            const peopleToInform = '';
            this.setState(() => ({
                peopleToInform,
            }));
            const submit = this.go(peopleToInform);
            if (submit) {
                this.props.onPeopleToInformSubmit(peopleToInform);
            }
        }
    }

    render() {

        const countryList = this.state.countryList;
        return (
            <form onSubmit={this.onSubmit}>
                <p>
                    Souhaitez-vous informer une ou plusieurs personnes de votre décès ?
                </p>
                <div className="alternate-radio-buttons">
                    <ButtonRadio
                        type="radio"
                        _id="addPeople1"
                        name="addPeople"
                        value="1"
                        checked={this.state.addPeople == "1"}
                        onChange={this.handleOnChange.bind(this, 'addPeople')}
                        label="Oui"
                    />
                    <ButtonRadio
                        type="radio"
                        _id="addPeople2"
                        name="addPeople"
                        value="0"
                        checked={this.state.addPeople == "0"}
                        onChange={this.handleOnChange.bind(this, 'addPeople')}
                        label="Non"
                    />
                </div>
                    
                {!this.state.disabled &&     
                	<h4>Je souhaite que ces personnes soient informées de mon décès : </h4>
                }
                
                {!this.state.disabled && this.state.peopleToInform && this.state.peopleToInform.map((person, i) =>
                    <div className="row" key={i}>
                        { /* i === '0' &&
                            // DISPLAY PHOTO IF FIRST PERSON
                           <div className="col-sm-4">
                                <p>NABIL</p>
                            </div> */
                        }
                        <div className="col-sm-12 form-container">
                            <div className="first-person">
                                {i > 0 &&
                                    <div className="delete-item-button" onClick={() => this.removePerson(person.id)} >&nbsp;Supprimer&nbsp;</div>
                                }
                                <h4 className="top-title"><div className="icon-title _person"></div>Personne {i + 1} </h4>
                                <div className="row">
                                    <div className="col">
                                        <Field
                                            label="Nom *"
                                            type="text"
                                            name={person.id}
                                            _className={"form-control address " + person.error.name}
                                            value={person.name}
                                            onChange={this.onPersonChange.bind(this, "name")}
                                            error={person.error.name}
                                        />
                                        <Field
                                            label="Prénom *"
                                            type="text"
                                            name={person.id}
                                            _className={"form-control address " + person.error.firstName}
                                            value={person.firstName}
                                            onChange={this.onPersonChange.bind(this, "firstName")}
                                            error={person.error.firstName}
                                        />
                                        <Field
                                            label="Téléphone *"
                                            type="text"
                                            name={person.id}
                                            _className={"form-control address " + person.error.tel}
                                            value={person.tel}
                                            onChange={this.onPersonChange.bind(this, "tel")}
                                            error={person.error.tel}
                                        />
                                        <div className="required-txt _screen"> * Champs obligatoires</div>
                                    </div>
                                    <div className="col">
                                        <Field
                                            label="Adresse *"
                                            type="text"
                                            name={person.id}
                                            _className={"form-control address " + person.error.address}
                                            value={person.address}
                                            onChange={this.onPersonChange.bind(this, "address")}
                                            error={person.error.address}
                                        />
                                        <div className="row zip-container">
                                            <div className="col-4 _col-first">
                                                <Field
                                                    label="Code postal *"
                                                    type="text"
                                                    name={person.id}
                                                    _className={"form-control address " + person.error.zipCode}
                                                    value={person.zipCode}
                                                    onChange={this.onPersonChange.bind(this, "zipCode")}
                                                    error={person.error.zipCode}
                                                />
                                            </div>
                                            <div className="col">
                                                <Field
                                                    label="Ville *"
                                                    type="text"
                                                    name={person.id}
                                                    _className={"form-control address " + person.error.city}
                                                    value={person.city}
                                                    onChange={this.onPersonChange.bind(this, "city")}
                                                    error={person.error.city}
                                                />
                                            </div>
                                        </div>
                                        <Select
                                            label="Pays *"
                                            name={person.id}
                                            _className={"form-control address " + person.error.country}
                                            value={person.country ? person.country : "79" }
                                            onChange={this.OnPersonPaysChange.bind(this, 'country', i)}
                                        	error={person.error.country}
                                            list={countryList}
                                            selectType="obj"
                                            optionValue="id"
                                            optionLabel="libelle"
                                        />
                                        <Field
                                            label="Email *"
                                            type="email"
                                            name={person.id}
                                            _className={"form-control address " + person.error.email}
                                            value={person.email}
                                            onChange={this.onPersonChange.bind(this, "email")}
                                            error={person.error.email}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="required-txt _mobile"> * Champs obligatoires</div>
                            <div className="separator-list"></div>
                        </div>
                    </div>

                )}
                <div className="col-sm-12  form-container align-center">
                	{!this.state.disabled &&
                		<button type="button" className="btn btn-outline-primary btn-sm btn-icon" onClick={this.addPerson} disabled={this.state.disabled}><div className="icon-button">+</div>  Ajouter une personne  </button>
                	}
                	<div className="button-container">
                        <button type="submit" className="btn btn-outline-primary" onClick={this.props.back}>{"< Precedent"}</button>
                        <button type="submit" className="btn btn-primary" >Suivant ></button>
                    </div>
                </div>
            </form>
        )
    }
}


export default PeopleToInformFrom;


// WEBPACK FOOTER //
// ./src/components/ObituaryPage/PeopleToInformFrom.js